function isDalleInSelected(toCompare,listDalles) {
    
}

function getIndexRemove(idDalle,listDalle){

    for (var index=0; index<listDalle.length; index++){
        
        if (
          listDalle[index].id ===
          idDalle
        ) {
          return index;
        }
      };

}

export  {getIndexRemove}